<template>
  <fullscreen-modal :show-close-button="false">
    <div></div>
    <spinner-loader v-if="isLoading"></spinner-loader>
  </fullscreen-modal>
</template>
<script>
import FullscreenModal from "./shared/Fullscreen-modal.vue";
import SpinnerLoader from "./shared/SpinnerLoader.vue";
import api from "../api";
import { mapState, mapGetters } from "vuex";

export default {
  name: "ShopifyIntegration",
  components: { FullscreenModal, SpinnerLoader },
  beforeRouteEnter(t, f, next) {
    next(async (vm) => {
      vm.init();
    });
  },
  data() {
    return { isLoading: true, isProcessing: false };
  },
  computed: {
    ...mapState(["site"]),
    ...mapGetters({
      isOnboardingComplete: "site/isOnboardingComplete",
    }),
  },
  methods: {
    async init() {
      if (this.isProcessing) return;
      this.isProcessing = true;
      this.isLoading = true;
      try {
        let { shop, isFirstInstall, isIntegration, host } = this.$route.query;

        // 1. Handle missing shop by deriving it from host (common in App Bridge v4)
        if (!shop && host) {
          try {
            const decodedHost = atob(host);
            if (decodedHost.includes("admin.shopify.com/store/")) {
              shop = `${decodedHost.split("/").pop()}.myshopify.com`;
            } else {
              shop = decodedHost;
            }
          } catch (e) {
            console.error("Failed to decode host parameter:", e);
          }
        }

        // 2. Check if required to go through Oauth
        // For new installs or when explicitly not a first install, we might need a fresh OAuth
        if (!isFirstInstall && shop) {
          const { authUrl } = await api.processShopifyAuth({ shop, host });
          if (authUrl) {
            try {
              return (window.top.location.href = authUrl);
            } catch (error) {
              console.error("Failed to redirect to authUrl:", error);
            }
          }
        }

        // 3. Ensure Shopify App Bridge is available
        if (!window.shopify) {
          console.error("Shopify App Bridge not found. Make sure it's installed and configured correctly.");
          // If we don't have shop, we can't do anything else
          if (!shop) return;
        }

        // 4. Retrieve Shopify Session Token (The New Way)
        let sessionToken;
        if (window.shopify) {
          try {
            // idToken() replaces getSessionToken(app)
            sessionToken = await window.shopify.idToken();
          } catch (err) {
            console.error(`Error retrieving idToken: ${err}`);
          }
        }

        // 5. Log user in with your backend
        if (sessionToken) {
          try {
            await this.$store.dispatch("account/logShopifyUser", { sessionToken });
          } catch (err) {
            console.error(`Err logging in shopify user: ${err}`);
            // If logging in with session token fails, it might be because the app is not installed
            // Fallback to process auth if not already done
            if (shop) {
              const { authUrl } = await api.processShopifyAuth({ shop, host });
              if (authUrl) {
                return (window.top.location.href = authUrl);
              }
            }
          }
        } else if (shop && !isFirstInstall) {
           // Fallback if no session token but we have shop
           const { authUrl } = await api.processShopifyAuth({ shop, host });
           if (authUrl) {
             return (window.top.location.href = authUrl);
           }
        }

        // 6. Finalize login and redirect
        if (this.$store.state.account.user) {
          await this.$store.dispatch("site/getSite", {
            siteId: this.$store.state.account.user.siteId,
          });

          if (isFirstInstall || !this.isOnboardingComplete) {
            const route = { name: "onboarding" };
            if (isFirstInstall) {
              route.query = { firstSession: true };
            }
            this.$router.push(route);
          } else {
            this.$router.push({ name: "dashboard" });
          }
        } else {
          console.error("Authentication failed: No user found after login attempts.");
          this.isLoading = false;
          this.isProcessing = false;
        }
      } catch (err) {
        console.error(`Err Auth Shopify: ${err}`);
        this.isLoading = false;
        this.isProcessing = false;
      }
    },
  },
};
</script>

<style lang="scss"></style>
